import { render } from "./AgencyPage.vue?vue&type=template&id=c4197f90&scoped=true"
import script from "./AgencyPage.vue?vue&type=script&lang=js"
export * from "./AgencyPage.vue?vue&type=script&lang=js"

import "./AgencyPage.vue?vue&type=style&index=0&id=c4197f90&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4197f90"]])

export default __exports__